import { Component, OnInit } from '@angular/core';
import { ReservationListItemComponent } from '../reservation-list-item/reservation-list-item.component';

@Component({
  selector: '[app-compact-reservation-list-item]',
  templateUrl: './compact-reservation-list-item.component.html',
  styleUrls: ['./compact-reservation-list-item.component.scss']
})
export class CompactReservationListItemComponent extends ReservationListItemComponent {
  
}
